export function getMeta(url: string, callback: any) {
  const img = new Image();
  img.src = url;
  img.onload = function () {
    callback(this);
  };
}
